import React from "react";
import { TrendingUp, Users, ShoppingBag, DollarSign } from "lucide-react";

const Dashboard = () => {
  return (
    <div className="space-y-8">
      
      {/* HEADER */}
      <div>
        <h2 className="text-3xl text-white font-light">Dashboard Overview</h2>
        <p className="text-zinc-500 mt-1">Welcome back, here's what's happening today.</p>
      </div>

      {/* STAT CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard 
          title="Total Enquiries" 
          value="1,240" 
          change="+12%" 
          icon={<Users size={24} className="text-blue-400" />} 
        />
        <StatCard 
          title="Pending Quotations" 
          value="45" 
          change="+5%" 
          icon={<ShoppingBag size={24} className="text-amber-400" />} 
        />
        <StatCard 
          title="Revenue (Month)" 
          value="₹ 4.2M" 
          change="+18%" 
          icon={<TrendingUp size={24} className="text-emerald-400" />} 
        />
        <StatCard 
          title="Active Projects" 
          value="12" 
          change="On Track" 
          icon={<DollarSign size={24} className="text-purple-400" />} 
        />
      </div>

      {/* RECENT ACTIVITY SECTION (Placeholder) */}
      <div className="grid lg:grid-cols-3 gap-8">
        
        {/* Recent Queries Table */}
        <div className="lg:col-span-2 bg-[#1c1c1c] border border-zinc-800 rounded-2xl p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg text-white font-medium">Recent Enquiries</h3>
            <button className="text-xs text-amber-500 uppercase tracking-widest hover:underline">View All</button>
          </div>
          
          <table className="w-full text-left">
            <thead>
              <tr className="text-zinc-500 text-xs uppercase tracking-wider border-b border-zinc-800">
                <th className="pb-3">Client</th>
                <th className="pb-3">Type</th>
                <th className="pb-3">Status</th>
                <th className="pb-3 text-right">Date</th>
              </tr>
            </thead>
            <tbody className="text-sm text-zinc-300">
              {[1, 2, 3, 4].map((item) => (
                <tr key={item} className="border-b border-zinc-800/50 last:border-0 hover:bg-zinc-800/30 transition-colors">
                  <td className="py-4">Rahul Sharma</td>
                  <td className="py-4">Interior Design</td>
                  <td className="py-4"><span className="px-2 py-1 bg-amber-500/10 text-amber-500 rounded text-xs">New</span></td>
                  <td className="py-4 text-right">Oct 24</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Quick Actions / Notifications */}
        <div className="bg-[#1c1c1c] border border-zinc-800 rounded-2xl p-6">
           <h3 className="text-lg text-white font-medium mb-4">Quick Actions</h3>
           <div className="space-y-3">
             <button className="w-full py-3 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 rounded-lg text-sm transition-all text-left px-4">
               + Create New Quotation
             </button>
             <button className="w-full py-3 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 rounded-lg text-sm transition-all text-left px-4">
               + Add New User
             </button>
             <button className="w-full py-3 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 rounded-lg text-sm transition-all text-left px-4">
               + View Daily Report
             </button>
           </div>
        </div>

      </div>
    </div>
  );
};

// Helper Component for Stats
const StatCard = ({ title, value, change, icon }: any) => (
  <div className="bg-[#1c1c1c] border border-zinc-800 p-6 rounded-2xl hover:border-amber-500/30 transition-all shadow-xl">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-zinc-500 text-xs uppercase tracking-widest mb-2">{title}</p>
        <h3 className="text-2xl font-bold text-white">{value}</h3>
      </div>
      <div className="p-3 bg-zinc-900 rounded-xl border border-zinc-800">
        {icon}
      </div>
    </div>
    <div className="mt-4 flex items-center gap-2">
      <span className="text-emerald-400 text-xs font-bold bg-emerald-400/10 px-2 py-0.5 rounded">{change}</span>
      <span className="text-zinc-600 text-xs">from last month</span>
    </div>
  </div>
);

export default Dashboard;